import { isTestCafeEnabled } from '@/helpers/isTestCafeEnabled'

export class PaymentEndpointResolver {
    constructor () {
        this.isTestCafeEnabled = isTestCafeEnabled
    }

    resolve () {
        if (this.isTestCafeEnabled()) {
            return process.env.VUE_APP_TESTCAFE_PAYMENT_ENDPOINT
        }

        return process.env.VUE_APP_PAYMENT_ENDPOINT
    }
}
